<rt-input
  [formControl]="timeControl"
  [placeholder]="placeholder"
  [width]="fullWidth ? 'auto' : '120px'"
  [class.dropdownOpened]="state.dropdownOpen"
  [hasDropdownIndicator]="true"
  [invalid]="invalid"
  (valueChange)="onTimeChange($event)"
  (click)="toggleDropdown()"
  rt-overlay-origin
  #timeDropdownTrigger="rtOverlayOrigin"
  variant="rounded"
/>
<ng-template
  (backdropClick)="toggleDropdown(false)"
  [origin]="timeDropdownTrigger"
  [open]="state.dropdownOpen"
  [width]="dropdownWidth"
  #timeDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
>
  <rt-time-picker-dropdown
    [currentSelected]="time"
    [timeInterval]="timeInterval"
    (timeSelect)="onTimeChange($event)"
  />
</ng-template>
